import Sidebar from './Sidebar';

export default function Layout({ children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f7f7f7', fontFamily: "'Barlow', sans-serif" }}>
      <Sidebar />
      <main style={{ marginLeft: '220px', flex: 1, padding: '40px', minHeight: '100vh' }}>
        {children}
      </main>
    </div>
  );
}
